import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = ({ pageCreateContract }) => {
    return (
        <ContentLoader
            speed={2}
            width={1464}
            height={122}
            viewBox={`0 0 1464 122`}
            backgroundColor='#f3f3f3'
            foregroundColor='#ecebeb'
        >
            <>
                <rect x='15' y='21' rx='3' ry='3' width='90' height='18' />
                <rect x='112' y='21' rx='3' ry='3' width='70' height='18' />
                <rect x='188' y='21' rx='3' ry='3' width='100' height='18' />
                {pageCreateContract && <rect x='999' y='15' rx='3' ry='3' width='150' height='35' />}
                <rect x='1158' y='15' rx='3' ry='3' width='145' height='35' />
                <rect x='1312' y='15' rx='3' ry='3' width='133' height='35' />

                <rect x='15' y='69' rx='3' ry='3' width='60' height='10' />
                <rect x='124' y='69' rx='3' ry='3' width='112' height='10' />
                <rect x='257' y='69' rx='3' ry='3' width='174' height='10' />
                <rect x='451' y='69' rx='3' ry='3' width='63' height='10' />
                <rect x='534' y='69' rx='3' ry='3' width='157' height='10' />
                <rect x='713' y='69' rx='3' ry='3' width='53' height='10' />
                <rect x='856' y='69' rx='3' ry='3' width='298' height='10' />

                <rect x='15' y='92' rx='3' ry='3' width='80' height='12' />
                <rect x='124' y='92' rx='3' ry='3' width='80' height='12' />
                <rect x='257' y='92' rx='3' ry='3' width='110' height='12' />
                <rect x='451' y='92' rx='3' ry='3' width='63' height='12' />
                <rect x='534' y='92' rx='3' ry='3' width='70' height='12' />
                <rect x='713' y='92' rx='3' ry='3' width='120' height='12' />
                <rect x='856' y='92' rx='3' ry='3' width='60' height='12' />
                <rect x='919' y='94' rx='3' ry='3' width='10' height='8' />
            </>        
        </ContentLoader>
    )
}

export default Loader